module.exports = __webpack_public_path__ + "img/17841_L.aa47d738.png";